import { IconButton, Tooltip } from '@mui/material'
import React,{useState,useEffect} from 'react'
import { useLocation,useNavigate } from 'react-router-dom'
// import { CreateLeadsListBasedonIdService, DeleteLeadService, GetLeadNoteService, GetLeadReminderService, GetLeadsService, SearchLeadService } from '../../services/LeadServices';
import moment from 'moment';
import {BsArrowRepeat} from 'react-icons/bs';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { DatePicker, Modal } from 'antd';
import {AiOutlineFilter,AiOutlinePlus,AiOutlineEdit,AiOutlineDelete, AiOutlineClose, AiOutlineDownload, AiOutlineStar} from 'react-icons/ai';
import { toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import DriveMenu from './DriveMenu';
import { CreateDriveService, DeleteAdminDriveService, DeleteDriveService, GetDeletedDriveService, GetDriveService, UpdateDriveService, UploadDriveFileService } from '../../services/DriveServices';
import { TextInput } from '../../components/input';
import axios from 'axios'
import fileDownload from "js-file-download";
import { RiStarFill } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import {CopyToClipboard} from 'react-copy-to-clipboard';


import docs from '../../images/icons/docs.png'
import folder from '../../images/icons/folder.png'
import list from '../../images/icons/list.png'
import pdf from '../../images/icons/pdf.png'
import photogallery from '../../images/icons/photo-gallery.png'
import xls from '../../images/icons/xls.png'
import youtube from '../../images/icons/youtube.png'


import { TbLayoutGrid } from "react-icons/tb";
import { IoIosList } from "react-icons/io";
import { RiCheckFill } from "react-icons/ri";
import { FiFileText } from "react-icons/fi";
import { MdFolderOpen } from "react-icons/md";
import { MdOutlineInsertLink } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { VscOpenPreview } from "react-icons/vsc";

import { MdRestore } from "react-icons/md";

function TrashList() {

  const location = useLocation();
  const user = useSelector(state=>state.Auth)
  const navigate = useNavigate();

  let path = location?.pathname?.split('/')[2]

  const [data,setdata]  = useState([])

  const [step,setstep] = useState(1)
  const [design,setdesign] = useState(1)
  const [selectedData,setselectedData] = useState({})
  const [singleData,setsingleData]  = useState({name:'',file:'',type:'',important:false,deleted:false})
  const [error,seterror]  = useState({name:'',file:'',type:'',important:'',deleted:''})
  const [modal,setmodal] = useState(false)
  const [modal1,setmodal1] = useState(false)
  const [page,setpage] = useState(1)
  const [filter_drawer,setfilter_drawer] = useState(false)


  const [selectedPath,setselectedPath] = useState([])

  const [search,setsearch] = useState({text:'',from_date:'',to_date:'',from_date1:'',to_date1:'',activate:false})

 
  
 

  useEffect(()=>{
    getdata(page)
  },[page])


  
  async function getdata(page){
    setfilter_drawer(false)
    const response =  await GetDeletedDriveService(page,search?.text,search?.from_date1,search?.to_date1);
    setdata(response.data)
  }

  async function applyfilterfunction(page){
    // setsearch({...search,activate:true})
    // let start_date = new Date(search?.from_date).toLocaleDateString().replaceAll('/','-').split('-').reverse().join('-')
    // let end_date = new Date(search?.to_date).toLocaleDateString().replaceAll('/','-').split('-').reverse().join('-')
    // const response = await FilterUserCallService({search_text:search.text,from_date:(search?.from_date !== ''  && search?.from_date !== null ) ? start_date : '',to_date:(search?.to_date !== ''  && search?.to_date !== null) ? end_date : '',page:page})
    // setdata(response.data)
  }

  async function resetfunc(){
    setsearch({text:'',from_date:'',to_date:'',activate:false})
    getdata(1)
  }

  const deletePermanently = async(v)=>{
    const response = await DeleteAdminDriveService(v)
    if(response?.status === 200){
      getdata(1)
      toast.success(response?.data?.data)
    }
  }

  function handlechange(e){
    setsingleData({...singleData,[e.target.name]:e.target.value})
    seterror({...data,[e.target.name]:''})
  }

  function getFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
    fileSizeInBytes /= 1024;
    i++;
    } while (fileSizeInBytes > 1024);
    return Math.max(fileSizeInBytes, 0.1).toFixed(1).slice(0,4) + byteUnits[i];
}

  async function uploadfilefunc(name,file,type,size) {
    let sendData = {
      name:name,
      file:file,
      type:type,
      fileSize:size
    }

    if(selectedPath.length > 0){
      sendData['subFolders'] = selectedPath[selectedPath?.length - 1]?._id
    }

    const response = await CreateDriveService(sendData)
    if(response?.status === 201){
      toast.success("Drive Created Successfully")
      getdata(1)
      setmodal1(false)
      setmodal(false)
      resetform1()
    }
    
  }

  async function createfolderfunc() {

    let sendData = {
      name:singleData.name,
    }


   

    if(singleData?._id === undefined){
      if(selectedPath.length > 0){
        sendData['subFolders'] = selectedPath[selectedPath?.length - 1]?._id
        sendData['type'] = "folder"
      }

      const response = await CreateDriveService(sendData)
      if(response?.status === 201){
        toast.success("Folder Created Successfully")
        getdata(1)
        setmodal1(false)
        setmodal(false)
        resetform1()
      }
    }else{
      const response = await UpdateDriveService(sendData,singleData?._id)
      if(response?.status === 200){
        toast.success(singleData?.type === 'folder' ? "Folder Renamed Successfully" : "File Renamed Successfully")
        getdata(1)
        setmodal1(false)
        setmodal(false)
        resetform1()
      }
    }
   
    
  }

  async function uploadsinglefile(file) {
    const fd = new FormData()
    fd.append('file',file)

    if(selectedPath.length > 0){
      fd.append('subFolders',selectedPath[selectedPath?.length - 1]?._id)
    }

    const response = await UploadDriveFileService(fd)
    if(response?.status == 200){
      uploadfilefunc(
        response?.data?.data?.split("/")[response?.data?.data?.split("/")?.length - 1]?.split('.')[0],
        response?.data?.data,
       ['jpeg','jpg','png','svg','avif','webp']?.includes(file?.type?.split('/')[1])?.length > 0 ?  "img" 
       :
       file?.type?.split('/')[1] == 'pdf' ? "pdf" 
       :
       ['mp4','mp3']?.includes(file?.type?.split('/')[1])?.length > 0 ? "video" 
       :
       ['xlsx','xls',"xlx"]?.includes(file?.type?.split('/')[1])?.length > 0 ? "xlsx" 
       :
       file?.type?.split('/')[1] == "zip" ? "zip" : "",
          file?.size
      )
    }
      // setsingleData({...singleData,file:response?.data?.data,name:response?.data?.data?.split("/")[response?.data?.data?.split("/")?.length - 1]})
  }

  async function resetform1() {
    setsingleData({name:'',file:'',type:'',important:false,deleted:false})
    seterror({name:'',file:'',type:'',important:'',deleted:''})
  }

  async function downloadfile(url,name) {
      axios.get(`${process.env.REACT_APP_AWS_IMAGE_URL}${url}`, {
          responseType: 'blob',
      })
          .then((res) => {
              fileDownload(res.data, name)
              toast.success("Attachment Downloaded") 
          })
  }

  async function markasimportantfunc(d) {
    let sendData = {...d}
    sendData['important'] = d?.important ? false :true
    const response = await UpdateDriveService(sendData,d?._id)
    if(response?.status == 200){
      toast.success("Status Updated")
      getdata(1)
    }
    
  }

  async function setselectedfuncpath(v) {
    let oldPath = [...selectedPath]
    oldPath.push(v)
    setselectedPath(oldPath)
  }

  async function setselectedPathfunc(p) {
    const findIndex = selectedPath?.findIndex((f)=>f?._id === p?._id)
    if(findIndex >= 0){
    let oldselectedPath = [...selectedPath]
    let result =  oldselectedPath.splice(0,findIndex + 1)
    setselectedPath(result)
    }
  }


  function previewfilefunc(v){
    window.open(`${process.env.REACT_APP_AWS_IMAGE_URL}${v}`,'_blank')
  }

  async function restoreData(id) {
    const response = await UpdateDriveService({deleted:false},id)
    if(response?.status == 200){
        toast.success(`Restored Successfully !`)
        getdata(1)
    }
  }


  


  return (
    <div className='h-screen w-full  flex max-h-screen '>

      <Modal open={modal} closable={false} footer={false} className='absolute top-0 left-[32%]'>
        <div className='relative'>
             <AiOutlineClose className='absolute right-0 cursor-pointer' onClick={()=>setmodal(!modal)} />
             <h6 className='font-[600] text-[14px] '>Select Any of the option to continue</h6>

            <div className='grid mt-5 grid-cols-2 gap-5'>
              <div onClick={()=>{setmodal1(true);setsingleData({})}} className='border p-2 bg-slate-100'>
                <h6>New Folder</h6>
              </div>

              <form onClick={()=>document.querySelector('.input-field').click()}>
              <div className='border p-2 bg-slate-100' onClick={()=>{}}>
                <h6>File Upload</h6>
              </div>
              <input type='file' onChange={({target:{files}})=>{
                files[0] && uploadsinglefile(files[0])
              }} accept="*" className='input-field' hidden />
              </form>
             </div> 

            
        </div>

      </Modal>

      <Modal open={modal1} closable={false} width={300} footer={false} className='md:absolute w-[150px] md:top-0 md:left-[40%]'>
          
          <> 
          {((selectedData?.type === 'folder' && selectedData?._id !== undefined) || selectedData?._id === undefined) &&
          <h6 className='font-[700] mb-4'>{singleData?._id !== undefined ? 'Rename Folder' :  `Create New Folder`} </h6>}

        {(selectedData?.type !== 'folder') &&
          <h6 className='font-[700] mb-4'>{singleData?._id !== undefined && 'Rename File Name'} </h6>}

          <TextInput 
                mandatory={true}
                label={''}  
                variant="standard"
                name="name"
                type="text"
                value={singleData.name}
                error={error.name}
                handlechange={handlechange}
                placeholder="Enter contact mobile"
                InputLabelProps={{
                    style: { color: '#fff', }, 
                }}/>
            </>


        <div className='flex border-t  pt-2 mt-2 justify-end'>
          <ButtonOutlinedAutoWidth onClick={()=>{setmodal1(false);setsingleData({})}} btnName="Cancel" />
          <div className='mr-2'></div>

          <ButtonFilledAutoWidth onClick={()=> createfolderfunc()} btnName="Save" />
        </div>
      </Modal>
  
     <DriveMenu />
      <div className='px-3 md:px-4  pt-4 w-[100%]'>
      <div  className={`${data?.datas?.length === 0 ? 'w-[100%]' : 'w-[100%] md:w-[96%]'}`}>
        <div  className='w-[100%] '>
          <div className='block   md:flex items-center justify-between border-b pb-2'>
            <div className='flex justify-between items-center'>
              <h6 className='font-[500] text-[13px] '>Trashed Drive Item </h6>
              <div className='block md:hidden  items-center'>
              <div className='flex items-center text-[12px] -mr-2 md:mr-2'>

                <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
                <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

                <div>
                <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>
                <IconButton onClick={()=>{page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0)  ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

                </div>
              </div>
              </div>
              </div>

              <div className='flex items-center md:justify-between mt-2 md:mt-0'>
              <div className='hidden md:block  items-center'>
              <div className='flex items-center text-[12px] -mr-2 md:mr-2'>

                <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
                <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

                <div>
                <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>
                <IconButton onClick={()=>{page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0)  ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

                </div>
              </div>
              </div>
              <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.from_date} onChange={(v) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,from_date:v})}} /> 

              <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.to_date} onChange={(v) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,to_date:v})}} /> 

              <div className='mr-2'>
              <input  id="search_text" placeholder='Search Drive' type='text' value={search.text} onChange={(e)=>setsearch({...search,text:e.target.value})} className=' text-[12px] border py-[6.5px] focus:ring-0 focus:outline-0 w-[70px] md:w-28 px-2 rounded-md border-slate-300' />
              </div>      

              <div className='hidden md:block'>
              <ButtonOutlinedAutoWidth btnName="Add Filter" onClick={()=>applyfilterfunction(1)} /> 
              </div>
              <AiOutlineFilter onClick={()=>applyfilterfunction(1)}  size={26} className='border-slate-300 bg-[#f6f8fa] rounded-[3px] px-1 p-1 text-[#000] block md:hidden' />
              </div>
        </div>
        
        {selectedPath?.length > 0 &&
        <div className='flex flex-wrap py-2'>
           <h6 onClick={()=>setselectedPath([])} className='text-[12px] font-bold p-1.5 px-3 rounded-full hover:bg-slate-100 cursor-pointer'>My Drive</h6>

           {selectedPath?.map((p)=>(
            <div key={p?._id} onClick={()=>setselectedPathfunc(p)} className='flex items-center'>
             <MdKeyboardArrowRight className='text-gray-400' />
             <h6 className='text-[12px] font-bold p-1.5 px-3 rounded-full hover:bg-slate-100 cursor-pointer'>{p?.name}</h6>
            </div>  
           ))}
        </div>}


        {selectedData?._id !== undefined &&
        <div className='py-2.5 mt-2 relative flex items-center bg-slate-100 rounded-full'>

          <h6 className='text-[12px] font-[700] pl-3'>1 File Selected</h6>

          <div className='flex items-center ml-4'>
            {(selectedData?.type !== 'folder' && selectedData?.file !== '') && <AiOutlineDownload onClick={()=>downloadfile(selectedData?.file,selectedData?.name)} size={13} className='mr-2' />}
            <AiOutlineDelete onClick={()=>deletePermanently(selectedData?._id)} size={13} className='mr-2' />
          

            {(selectedData?.type !== 'folder') && 
            <VscOpenPreview className='mr-2' size={14} onClick={()=>previewfilefunc(selectedData?.file)}  />
            }

            <MdRestore onClick={()=>restoreData(selectedData?._id)} size={13} />

          </div>

          <AiOutlineClose onClick={()=>setselectedData({})} size={14} className='absolute cursor-pointer right-3' />
        </div>}
        
       
         


         <div className='mt-1.5 flex justify-between'>
         
         <div className='flex items-center'>
          </div>


          <div className='flex items-center border-2 cursor-pointer w-max overflow-hidden rounded-full'>
            <div onClick={()=>setdesign(1)} className={`flex p-1.5 px-2 ${design == 1 && 'bg-slate-700 text-white'} items-center`}>
              {design == 1 && <RiCheckFill className='text-[14px] mr-1' />}
              <IoIosList />
            </div>
            <div onClick={()=>setdesign(2)} className={`flex p-1.5 px-2 ${design == 2 && 'bg-slate-700 text-white'} items-center`}>
              {design == 2 && <RiCheckFill className='text-[14px] mr-1' />}
              <TbLayoutGrid />
            </div>


          </div>


         </div>

         {data?.datas?.length === 0 &&
          <div className='grid place-items-center mt-20  items-center justify-center'>
          <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
          <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
          <h6 className='font-[400] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
        </div>
        }
       

        {data?.datas?.length > 0 &&
        <div className='max-h-[85vh] relative w-auto mt-2 overflow-y-scroll'>

        {design == 1 &&
        <>
        <div className='flex sticky w-max md:w-[100%]  bg-white top-0 border-b border-t py-2 mb-1'>
          <h6 className='text-[13px] font-[700] w-[280px] min-w-[280px] max-w-[280px] md:min-w-[50%] md:max-w-[50%] md:w-[50%]'>Name</h6>
          <h6 className='text-[13px] font-[700] w-[150px] min-w-[150px] max-w-[150px] md:min-w-[20%] md:max-w-[20%] md:w-[20%]'>Owner</h6>
          <h6 className='text-[13px] font-[700] w-[150px] min-w-[150px] max-w-[150px] md:min-w-[20%] md:max-w-[20%] md:w-[20%]'>File Size</h6>
          <h6 className='text-[13px] font-[700] w-[150px] min-w-[150px] max-w-[150px] md:min-w-[10%] md:max-w-[10%] md:w-[10%]'>Action</h6>
        </div>  

        {data?.datas?.map((d,i)=>(
          <div onDoubleClick={()=>d?.type == 'folder' && setselectedfuncpath(d)} onClick={()=>selectedData?._id === d?._id ? setselectedData({}) : setselectedData(d)} key={d?._id} className={`flex group pt-[6px] pb-[10px] border-b border-slate-50 hover:bg-sky-50 ${selectedData?._id === d?._id && "bg-sky-50"} `}>

            <div className='w-[280px] min-w-[280px] max-w-[280px]  md:min-w-[50%] md:max-w-[50%] md:w-[50%] flex items-center'> 
               
               <div className='pl-2'>
                {d?.type == 'docs' &&
                <img src={docs} className='w-[20px] h-[20px] object-contain' />}
                {d?.type == 'folder' &&
                <img src={folder} className='w-[18px] h-[18px] object-contain' />}
                {d?.type == '' &&
                <img src={list} className='w-[20px] h-[20px] object-contain' />}
                {d?.type == 'pdf' &&
                <img src={pdf} className='w-[18px] h-[18px] object-contain' />}
                {d?.type == 'img' &&
                <img src={photogallery} className='w-[20px] h-[20px] object-contain' />}
                {d?.type == 'xlsx' &&
                <img src={xls} className='w-[20px] h-[20px] object-contain' />}
                {d?.type == 'video' &&
                <img src={youtube} className='w-[18px] h-[18px] object-contain' />}
               </div> 

               <h6 className='text-[12px] w-[70%] md:w-[100%] break-all pl-2'>{d?.name}</h6>
            </div>

            <div className='w-[150px] min-w-[150px] max-w-[150px]  md:min-w-[20%] md:max-w-[20%] md:w-[20%] flex items-center text-[10px]'> 
              <div className='uppercase text-[10px] mr-2 font-[400] px-[6px] py-[3px] bg-slate-700 text-white rounded-full'>{d?.created_by?.name?.slice(0,1)}</div>
              <h6 className='capitalize break-all'>{d?.created_by?.name}</h6>
            </div>  

            <div className='w-[150px] min-w-[150px] max-w-[150px]  md:min-w-[20%] md:max-w-[20%] md:w-[20%] text-[12px]'> 
             {(d?.fileSize === '' || d?.type === 'folder')&& <span className='text-slate-400 '> __</span>}
             {(d?.fileSize !== '' || d?.type !== 'folder') && d?.fileSize !== undefined && <span className='font-[700] text-[10px]'>{getFileSizeString(d?.fileSize)}</span>}
            </div> 

            <div className='w-[150px] min-w-[150px] max-w-[150px]   md:min-w-[10%] md:max-w-[10%] md:w-[10%] hidden cursor-pointer mt-1 group-hover:flex'>

             {(d?.type !== 'folder' && d?.file !== '') && <AiOutlineDownload onClick={()=>downloadfile(d?.file,d?.name)} size={13} className='mr-2' />}
              <AiOutlineDelete onClick={()=>deletePermanently(d?._id)} size={13} className='mr-2' />

              <MdRestore onClick={()=>restoreData(d?._id)} size={13} />

            </div>  

          </div>  
        ))}
        </>}

        {design == 2 &&
        <div className='grid grid-cols-2 md:grid-cols-4 mb-10 pt-5 border-t gap-5'>

          {data?.datas?.map((d)=>(
            <div onClick={()=>setselectedData(d)} className='bg-slate-100 p-4 rounded-[8px] overflow-hidden' key={d?._id}> 

               <div className={`flex relative items-center -ml-1 ${step == 1 && 'pb-2'}`}>
                  <div >
                    {d?.type == 'docs' &&
                    <img src={docs} className='w-[20px] h-[20px] object-contain' />}
                    {d?.type == 'folder' &&
                    <img src={folder} className='w-[18px] h-[18px] object-contain' />}
                    {d?.type == '' &&
                    <img src={list} className='w-[20px] h-[20px] object-contain' />}
                    {d?.type == 'pdf' &&
                    <img src={pdf} className='w-[18px] h-[18px] object-contain' />}
                    {d?.type == 'img' &&
                    <img src={photogallery} className='w-[20px] h-[20px] object-contain' />}
                    {d?.type == 'xlsx' &&
                    <img src={xls} className='w-[20px] h-[20px] object-contain' />}
                    {d?.type == 'video' &&
                    <img src={youtube} className='w-[18px] h-[18px] object-contain' />}
                  </div> 
                  <h6 className='ml-2 text-[11px] truncate font-[600] w-[70%]'>{d?.name}</h6>
                
                <BsThreeDotsVertical className='absolute right-0' />

                  </div> 

                {step == 1 &&
                <div className='bg-white flex h-[120px] md:h-[130px] items-center justify-center p-2 rounded-[4px] mb-2'>
                {d?.type == 'docs' &&
                    <img src={docs} className='w-[120px] h-[120px] object-contain' />}
                    {d?.type == 'folder' &&
                    <img src={folder} className='w-[100px] h-[100px] object-contain' />}
                    {d?.type == '' &&
                    <img src={list} className='w-[120px] h-[120px] object-contain' />}
                    {d?.type == 'pdf' &&
                    <img src={pdf} className='w-[100px] h-[100px] object-contain' />}
                    {d?.type == 'img' &&
                    <img src={photogallery} className='w-[120px] h-[120px] object-contain' />}
                    {d?.type == 'xlsx' &&
                    <img src={xls} className='w-[120px] h-[120px] object-contain' />}
                    {d?.type == 'video' &&
                    <img src={youtube} className='w-[100px] h-[100px] object-contain' />}
                </div> }



                {step == 1 &&
               <div className='flex items-center'>
                <div className='-ml-1 flex items-center text-[10px]'> 
                  <div className='uppercase text-[10px] mr-2 font-[400] px-[6px] py-[3px] bg-slate-700 text-white rounded-full'>{d?.created_by?.name?.slice(0,1)}</div>
                  <h6 className='text-gray-500 capitalize'>{d?.created_by?.name}</h6>
                </div>  
                <h6 className='text-gray-400 text-[11px] ml-2'>{moment(d?.updatedAt)?.format('lll')}</h6>
               </div> }
            </div>
          ))}

        </div>} 
       
        </div>}
        </div>

        
      


      </div>
      </div>
    </div>
  )
}

export default TrashList